import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { toast } from 'sonner';
import { Lock, User } from 'lucide-react';

const LoginPage = () => {
  const { login } = useAuth();
  const [loading, setLoading] = useState(false);
  const [loginData, setLoginData] = useState({ username: '', password: '' });

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(loginData.username, loginData.password);
      toast.success('تم تسجيل الدخول بنجاح');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'خطأ في تسجيل الدخول');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-start justify-center p-4 pt-8">
      <div className="w-full max-w-md">
        {/* Logo and Title */}
        <div className="text-center mb-6 animate-fade-in">
          <img 
            src="/assets/login-logo.png" 
            alt="الشعار" 
            className="w-80 h-80 mx-auto object-contain"
          />
          <p className="text-slate-500 -mt-2">نظام إدارة الشؤون الخاصة</p>
        </div>

        <Card className="border-0 shadow-xl animate-fade-in stagger-1" data-testid="auth-card">
          <CardHeader className="pb-4">
            <CardTitle className="text-xl text-center" style={{ color: '#1a365d' }}>مرحباً بك</CardTitle>
            <CardDescription className="text-center">
              سجل دخولك للوصول إلى لوحة التحكم
            </CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleLogin} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="login-username">اسم المستخدم</Label>
                <div className="relative">
                  <User className="absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-slate-400" />
                  <Input
                    id="login-username"
                    data-testid="login-username"
                    placeholder="أدخل اسم المستخدم"
                    className="pr-10"
                    value={loginData.username}
                    onChange={(e) => setLoginData({ ...loginData, username: e.target.value })}
                    required
                  />
                </div>
              </div>
              <div className="space-y-2">
                <Label htmlFor="login-password">كلمة المرور</Label>
                <div className="relative">
                  <Lock className="absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-slate-400" />
                  <Input
                    id="login-password"
                    data-testid="login-password"
                    type="password"
                    placeholder="أدخل كلمة المرور"
                    className="pr-10"
                    value={loginData.password}
                    onChange={(e) => setLoginData({ ...loginData, password: e.target.value })}
                    required
                  />
                </div>
              </div>
              <Button 
                type="submit" 
                className="w-full text-white"
                style={{ background: '#1a365d' }}
                data-testid="login-submit"
                disabled={loading}
              >
                {loading ? <span className="spinner ml-2"></span> : null}
                تسجيل الدخول
              </Button>
            </form>
          </CardContent>
        </Card>

        <p className="text-center text-sm text-slate-400 mt-6">
          نظام إدارة الشؤون الخاصة © {new Date().getFullYear()}
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
